import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import './tramites.css';
import { tramites_item } from '../../json/tramitesItem';

const Tramites = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);
    return (
        <div className='container tramites-container'>
            <div className='row'>
                <div className='col_12'>
                    <div className='tramites_title'>
                        <h1>Trámites y Servicios</h1>
                    </div>
                </div>
            </div>

            <div className='row'>
                        {
                      
                        tramites_item.map((item, index)=>(
                            <Link key={index} to={item.tramites_item_url } 
                            className='col-md-4 col-sm-6 col-12 tramites_enlace' >
                            <div className='tramites_container'>
                                <div className='tramites_icono'>
                                <img src={"/assets/imgs/" + item.icono} alt=''/>
                                </div>
                                <a>{ item.tramites_item_nombre }</a>
                            </div>
                            <div className='tramites_descripcion'>
                                <br></br>
                                <h6>{item.tramites_item_descripcion}</h6>
                            </div>
                            </Link>
                            
                        ))
                        }
            </div> 

            
         {/*    <div className='row'>
                {
                    tramites_item.map((item, index) => (
                        <div key={index} className='col-md-4 col-sm-6 col-12 tramites_item'>
                            <Link to={item.tramites_item_url}>
                                <div className='tramites_container'>
                                    <div className='tramites_icono'>
                                        <img src={"/assets/imgs/" + item.icono} />
                                    </div>
                                </div>
                                <br></br>
                                <h5>{item.tramites_item_nombre}</h5>
                            </Link>
                            <div className='tramites_descripcion'>
                                <br></br>
                                <h6>{item.tramites_item_descripcion}</h6>
                            </div>
                        </div>
                    ))
                }
            </div> */}
        </div>
    )
}

export default Tramites